import { render, staticRenderFns } from "./StdEvalItemList.vue?vue&type=template&id=74d931ac&"
import script from "./StdEvalItemList.vue?vue&type=script&lang=ts&"
export * from "./StdEvalItemList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports